// extracted by mini-css-extract-plugin
export default {"container":"_404_container__zMDBK","header":"_404_header__Rb7Di","icon":"_404_icon__qn3Ej","btn":"_404_btn__D8qKq"};